import { Language } from '@/__generated__/graphql';
import type { AppLocale } from './locale-storage';

/** El valor del enum del backend para un idioma de la app. */
export function toLanguageEnum(locale: AppLocale): Language {
  return locale === 'en' ? Language.En : Language.Es;
}

/**
 * El idioma de la app para el valor del backend. Sin valor (la query todavía no llegó) es `null`;
 * cualquier valor que no sea inglés cae a español, el default del producto.
 */
export function fromLanguageEnum(language: Language | null | undefined): AppLocale | null {
  if (language == null) return null;
  return language === Language.En ? 'en' : 'es';
}
